import { useContext } from 'react';
import { ImQrcode } from 'react-icons/im';
import { useIntl } from 'react-intl';

import { TerminalContext, TerminalContextInterface } from '../../../TerminalInit';
import { TerminalWorkflowType } from '../../../api/terminals';
import ActionCard from '../../../components/domain/ActionCard';
import { AllowedActionViewProps } from '../../../components/domain/AllowedAction';
import { isDelivery } from '../../../services/contact/GlobalPermissions';

type QRHelpActionProps = AllowedActionViewProps;

function QRHelpAction(props: QRHelpActionProps): ActionCard | undefined {
    const intl = useIntl();
    const { terminal } = useContext<TerminalContextInterface>(TerminalContext);

    if (
        // These define the BLOCKED cases
        terminal === null ||
        terminal.workflow === TerminalWorkflowType.WAREHOUSE ||
        terminal.workflow === TerminalWorkflowType.VENDING ||
        (terminal.workflow === TerminalWorkflowType.IMES_DEXIS_NIKE && !isDelivery(props.contact)) ||
        (terminal.workflow === TerminalWorkflowType.DELHAIZE && !isDelivery(props.contact))
    ) {
        return undefined;
    }

    return {
        actionText: intl.formatMessage({
            id: 'workflow.AuthenticatedContactWorkflow.QRCodeAction',
            description: 'This is the QR-code action for AuthenticatedContactWorkflow',
            defaultMessage: 'Scan code',
        }),
        icon: (
            <ImQrcode
                className='dashboard-action-icon'
                size={264}
            />
        ),
    };
}

export default QRHelpAction;
